var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox",on:{"click":_vm.click}},[(!_vm.value)?_c('img',{staticClass:"checkbox__img",attrs:{"src":require("../assets/box.png"),"alt":""}}):_c('img',{staticClass:"checkbox__img",attrs:{"src":require("../assets/checkBox.png"),"alt":""}}),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }